module.exports = __webpack_public_path__ + "img/sitdefault.61c81a33.png";